import { useState } from "react";
import { Outlet } from "react-router-dom";
import { Sidebar } from "@/components/layout/sidebar";
import { Header } from "@/components/layout/header";
import { useAuthUser } from "@/components/providers/auth-context";
import { useProvisioning } from "@/lib/hooks/use-provisioning";
import { useCurrentRole } from "@/lib/hooks/use-current-role";
import { ConnectedQuotaBanner } from "@/components/usage";
import { LocationScopedErrorBoundary } from "@/components/providers/route-error-boundary";

export function DashboardLayout() {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const { user } = useAuthUser();
  const { profile } = useProvisioning();
  const { role, isResolved } = useCurrentRole();

  const userInfo = {
    email: profile?.user.email,
    name: profile?.user.name ?? undefined,
    picture: user?.picture,
  };

  return (
    // `data-current-role` appears once provisioning has answered. A returning
    // user's page renders before then, as `viewer`, so "this control is not
    // offered" is only an observation about the role once it is set - which
    // is what the E2E role tests wait for (task 181).
    <div
      className="flex min-h-screen"
      data-current-role={isResolved ? role : undefined}
    >
      <Sidebar open={sidebarOpen} onClose={() => setSidebarOpen(false)} />
      {/* min-w-0: wide content (a table) scrolls in its own box rather
          than squeezing the sidebar. */}
      <div className="flex min-w-0 flex-1 flex-col">
        <Header onMenuClick={() => setSidebarOpen(true)} user={userInfo} />
        <main className="flex-1">
          <div className="px-4 pt-4 lg:px-6">
            <ConnectedQuotaBanner />
          </div>
          <LocationScopedErrorBoundary>
            <Outlet />
          </LocationScopedErrorBoundary>
        </main>
      </div>
    </div>
  );
}
